class DynamicSiteLogo {
    constructor() {
        this.body = document.querySelector("body");
        this.header = document.querySelector("header");
        this.logo = document.querySelector("img.custom-logo");
        this.solidHeaderContainer = document.querySelector("main.solid-header__body-container");

        const currentSrc = this.logo ? this.logo.getAttribute("src") : "";

        const hasSettings = typeof window !== "undefined" && typeof window.wpApiSettings !== "undefined";

        if (hasSettings) {
            this.lightLogo = window.wpApiSettings.light_logo || currentSrc;
            this.darkLogo = window.wpApiSettings.dark_logo || this.lightLogo;
        } else {
            this.darkLogo = currentSrc;
            this.lightLogo = currentSrc;
        }

        this.init();
    }

    init() {
        if (
            this.solidHeaderContainer
            || this.body.classList.contains('page-template-text')
            || this.body.classList.contains('page-template-wide')
        ) {
            this.header.classList.add("header__always-dark");
            this.showDarkLogo();
        }

        // Listen for scroll to toggle sticky / dark header
        window.addEventListener("scroll", () => this.changeHeader());

        // Apply initial state based on current scroll position (usually top of page)
        this.changeHeader();
    }

    changeHeader() {
        this.scrollPos = window.scrollY;

        if (this.scrollPos > 200) {
            this.header.classList.add("header__sticky");
            this.showDarkLogo();
        } else {
            this.header.classList.remove("header__sticky");
            this.showLightLogo();
        }
    }

    showDarkLogo() {
        if (!this.logo.getAttribute('src').includes(this.darkLogo)) {
            this.logo.srcset = '';
            this.logo.src = this.darkLogo;
        }

        this.header.classList.remove("header__light");
        this.header.classList.add("header__dark");
    }

    showLightLogo() {
        if (this.header.classList.contains('header__always-dark')) return;

        if (!this.logo.getAttribute('src').includes(this.lightLogo)) {
            this.logo.srcset = '';
            this.logo.src = this.lightLogo;
        }

        this.header.classList.remove("header__dark");
        this.header.classList.add("header__light");
    }
}

export default DynamicSiteLogo;